import usePromoConfig from "./usePromoConfig.ts";
import BigPromo from "./BigPromo.tsx";
import AppPromo from "./AppPromo.tsx";
import CoachMePromo from "./CoachMePromo.tsx";

type PromoName = ReturnType<typeof usePromoConfig>["secondaryItem"];

export default function NamedPromo({
  name,
  className,
}: {
  name: PromoName;
  className?: string;
}) {
  const Component =
    name === "apps" ? AppPromo : name === "coachme" ? CoachMePromo : BigPromo;

  return <Component className={className} />;
}
